<template>
    <div class="bot-container">
        <div class="sidebar-container">
            <sidebar-menu :width="'185px'" :menu="menu" :collapsed="isCollapsed" :show-one-child="true"
                :disable-hover="false" :active="activeItem" :relative="false" :hide-toggle="false" :mobile-item="null"
                :mobile-breakpoint="768" :rtl="false" :theme="'default-theme'" class="sidebar-menu"
                @item-click="onItemClick" @toggle-collapse="onToggleCollapse">
                <template v-slot:header>
                    <div class="sidebar-header">
                        <h3 v-if="!isCollapsed">BOT</h3>
                        <h3 v-else>BOT</h3>
                    </div>
                </template>
                <template v-slot:toggle-icon>
                    <i :class="isCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
                </template>
                <template v-slot:footer>
                    <div class="sidebar-version">
                        <span>V{{ version }}</span>
                    </div>
                </template>
                <template v-slot:dropdown-icon>
                    <i class="el-icon-arrow-down"></i>
                </template>
            </sidebar-menu>
        </div>
        <div class="content-container" :class="{ 'expanded': isCollapsed }">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { SidebarMenu } from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import pkg from '../../../package.json'

export default {
    components: {
        SidebarMenu
    },
    data() {
        return {
            isCollapsed: false,
            activeItem: null,
            version: pkg.version,
            menu: [
                {
                    header: 'Menú Principal',
                    hiddenOnCollapse: true
                },
                {
                    title: 'Dashboard',
                    icon: 'el-icon-s-home',
                    href: {
                        name: 'bot-dashboard',
                        query: { token: window.sessionStorage.getItem('token') }
                    }
                },
                {
                    title: 'Normalizador',
                    icon: 'el-icon-s-operation',
                    href: {
                        name: 'bot-normalizador',
                        query: { token: window.sessionStorage.getItem('token') }
                    }
                },
                // {
                //     title: 'Registros',
                //     icon: 'el-icon-document-add',
                //     href: {
                //         name: 'bot-registros',
                //         query: { token: window.sessionStorage.getItem('token') }
                //     }
                // },
                // {
                //     title: 'Convenios',
                //     icon: 'el-icon-document',
                //     href: {
                //         name: 'bot-convenios',
                //         query: { token: window.sessionStorage.getItem('token') }
                //     }
                // },
                // {
                //     title: 'Pruebas',
                //     icon: 'el-icon-s-platform',
                //     href: {
                //         name: 'bot-pruebas',
                //         query: { token: window.sessionStorage.getItem('token') }
                //     }
                // },
                // {
                //     title: 'Configuraciones',
                //     icon: 'el-icon-setting',
                //     href: {
                //         name: 'bot-configuraciones',
                //         query: { token: window.sessionStorage.getItem('token') }
                //     }
                // },

                {
                    header: 'Módulos Especializados',
                    hiddenOnCollapse: true
                },
                {
                    title: 'Coordinación',
                    icon: 'el-icon-s-cooperation',
                    href: {
                        name: 'coordinacion-dashboard',
                        query: { token: window.sessionStorage.getItem('token') }
                    },
                    child: [
                        {
                            title: 'Panel de Control',
                            href: {
                                name: 'coordinacion-dashboard',
                                query: { token: window.sessionStorage.getItem('token') }
                            }
                        },
                        {
                            title: 'Registros',
                            href: {
                                name: 'coordinacion-registros',
                                query: { token: window.sessionStorage.getItem('token') }
                            }
                        },
                        {
                            title: 'Convenios',
                            href: {
                                name: 'coordinacion-convenios',
                                query: { token: window.sessionStorage.getItem('token') }
                            }
                        },
                        {
                            title: 'Pruebas',
                            href: {
                                name: 'coordinacion-pruebas',
                                query: { token: window.sessionStorage.getItem('token') }
                            }
                        }
                    ]
                },
                {
                    title: 'Dispositivos',
                    icon: 'el-icon-s-help',
                    href: {
                        name: 'dispositivos-dashboard',
                        query: { token: window.sessionStorage.getItem('token') }
                    },
                    child: [
                        // {
                        //     title: 'Panel de Control',
                        //     href: {
                        //         name: 'dispositivos-dashboard',
                        //         query: { token: window.sessionStorage.getItem('token') }
                        //     }
                        // },
                        {
                            title: 'Medicos',
                            href: {
                                name: 'dispositivos-medicos',
                                query: { token: window.sessionStorage.getItem('token') }
                            }
                        },

                        {
                            title: 'Pruebas',
                            href: {
                                name: 'dispositivos-pruebas',
                                query: { token: window.sessionStorage.getItem('token') }
                            }
                        }
                    ]
                },
                {
                    title: 'Change Log',
                    icon: 'el-icon-notebook-2',
                    href: {
                        name: 'bot-changelog',
                        query: { token: window.sessionStorage.getItem('token') }
                    }
                },
                {
                    title: 'Wise',
                    icon: 'el-icon-coin',
                    href: {
                        name: 'bot-wise',
                        query: { token: window.sessionStorage.getItem('token') }
                    }
                },
                {
                    header: 'Sistema',
                    hiddenOnCollapse: true
                },
                {
                    title: window.sessionStorage.getItem('nombre') || 'Usuario',
                    icon: 'el-icon-user',
                    disabled: true
                },
                {
                    title: 'Salir',
                    icon: 'el-icon-switch-button',
                    onClick: () => {
                        window.sessionStorage.clear()
                        this.$router.push('/')
                    }
                }
            ]
        }
    },
    methods: {
        onItemClick(event, item) {
            if (item.onClick) {
                item.onClick()
                return
            }
            if (item.href && typeof item.href === 'object' && item.href.name) {
                this.$router.push(item.href)
            }
        },
        updateActiveMenu() {
            this.activeItem = this.$route.name;
        },
        onToggleCollapse(collapsed) {
            this.isCollapsed = collapsed;
        }
    },
    watch: {
        '$route': {
            immediate: true,
            handler() {
                this.updateActiveMenu()
            }
        }
    },
    mounted() {
        this.updateActiveMenu()
    }
}
</script>

<style lang="scss" scoped>
.bot-container {
    display: flex;
    height: 100vh;
    width: 100%;
    position: relative;
}

.sidebar-container {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .sidebar-menu {
        height: 100%;
    }

    .sidebar-version {
        text-align: center;
        padding: 10px 0;
        color: #fff;
        font-size: 13px;
        border-top: 1px solid #e6e6e6;
        background: none;
    }

    .sidebar-header {
        padding: 15px;
        text-align: center;
        border-bottom: 1px solid #e6e6e6;

        h3 {
            margin: 0;
            color: #409EFF;
            font-size: 16px;
            font-weight: bold;
        }
    }
}

.content-container {
    flex: 1;
    padding: 0px;
    overflow-y: auto;
    margin-left: 185px;
    width: calc(100% - 185px);
    transition: all 0.3s ease;

    &.expanded {
        margin-left: 50px;
        width: calc(100% - 50px);
    }
}

:deep(.vsm--mobile-bg) {
    width: 185px !important;
    background: #409EFF !important;
}

:deep(.vsm--scroll-wrapper) {
    width: 185px !important;
}

:deep(.v-sidebar-menu .vsm--link_level-1.vsm--link_active .vsm--icon),
:deep(.vsm--link .vsm--icon:hover) {
    color: #fff;
    background-color: #409EFF;
}

:deep(.v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon),
:deep(.v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover .vsm--icon) {
    color: #fff;
    background-color: #1565c0;
}

:deep(.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active),
:deep(.v-sidebar-menu .vsm--link_level-1.vsm--link_active) {
    -webkit-box-shadow: 3px 0px 0px 0px #409EFF inset;
    box-shadow: 3px 0px 0px 0px #409EFF inset;
    background-color: #409EFF !important;
    color: #fff !important;

    .vsm--icon {
        color: #fff !important;
    }

    .vsm--title {
        color: #fff !important;
    }
}

:deep(.vsm--link[href="#"] .vsm--icon),
:deep(.vsm--link[href="#"] .vsm--title) {
    color: #fff;
}

:deep(.vsm--link[disabled]) {
    opacity: 1;
    cursor: default;

    .vsm--icon {
        color: #fff;
    }

    .vsm--title {
        color: #fff;
    }
}

:deep(.vsm--dropdown) {
    background-color: #2c3e50;
    border-left: 3px solid #409EFF;
}

:deep(.vsm--link_level-2) {
    padding-left: 20px;
    background-color: #34495e;

    &:hover {
        background-color: #409EFF;
    }
}

:deep(.vsm--link_level-2.vsm--link_active) {
    background-color: #409EFF;
    color: #fff;

    .vsm--title {
        color: #fff;
    }
}

:deep(.vsm--dropdown .vsm--link_level-2.vsm--link_hover) {
    background-color: #409EFF;
    color: #fff;

    .vsm--title {
        color: #fff;
    }
}

:deep(.vsm--dropdown .vsm--link_level-2:hover) {
    background-color: #409EFF;
    color: #fff;

    .vsm--title {
        color: #fff;
    }
}

:deep(.vsm--dropdown-icon) {
    color: #fff;
    font-size: 12px;
    transition: transform 0.3s ease;
}

:deep(.vsm--link_level-1.vsm--link_open .vsm--dropdown-icon) {
    transform: rotate(180deg);
}

:deep(.vsm--link_level-1:hover .vsm--dropdown-icon) {
    color: #fff;
}
</style>